import { PluginKey } from '@tiptap/pm/state';

const PhantomSuggesterKey = {
  mention: new PluginKey('phantomMention'),
  emoji: new PluginKey('phantomEmoji'),
  command: new PluginKey('phantomCommand'),
};

export default PhantomSuggesterKey;
